import { Permission } from "@pax/api-contract/common";
import { createFileRoute } from "@tanstack/react-router";
import { type StaffLocation, StaffWorkspace } from "@/features/staff/StaffWorkspace";
export const Route = createFileRoute("/_authenticated/staff")({
  staticData: { access: { anyOf: ["staff.manage"] } },
  validateSearch: (search: Record<string, unknown>): StaffLocation => ({
    tab:
      search.tab === "roles" || search.tab === "permissions" || search.tab === "accounts"
        ? search.tab
        : undefined,
    roleId: typeof search.roleId === "string" ? search.roleId : undefined,
    newRole: search.newRole === true || search.newRole === "true" || undefined,
    userId: typeof search.userId === "string" ? search.userId : undefined,
    withRoleId: typeof search.withRoleId === "string" ? search.withRoleId : undefined,
    accountId: typeof search.accountId === "string" ? search.accountId : undefined,
    permission: Permission.safeParse(search.permission).data,
  }),
  head: () => ({ meta: [{ title: "Manage staff · Pax.co" }] }),
  component: Page,
});
function Page() {
  const location = Route.useSearch();
  const navigate = Route.useNavigate();
  return <StaffWorkspace location={location} navigate={search => void navigate({ search })} />;
}
